/** UI-only welcome offer for users who have never purchased. */
export const NEW_USER_OFFER_DURATION_MS = 15 * 60 * 1000;

/** Extra stars shown as a limited-time bonus per pack (not applied at checkout). */
export const NEW_USER_OFFER_BONUS: Record<string, number> = {
  starter: 100,
  creator: 200,
  pro: 400,
};

export function getNewUserOfferBonus(packageId: string): number | null {
  return NEW_USER_OFFER_BONUS[packageId] ?? null;
}
